module.exports = __webpack_public_path__ + "static/media/19-6.ead477ed.mp3";